'use strict';

var jsxRuntime = require('react/jsx-runtime');

const PersonOfficeConfirm = ()=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                d: "M4 36H36",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M6 34C6 30.6863 8.68629 28 12 28H16C19.3137 28 22 30.6863 22 34V36H6V34Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M14 25C16.2091 25 18 23.2091 18 21C18 18.7909 16.2091 17 14 17C11.7909 17 10 18.7909 10 21C10 23.2091 11.7909 25 14 25Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M17 33.3286H21.2521L23.874 26H35L31.7967 36H25.9031H17",
                fill: "white"
            }),
            jsxRuntime.jsx("path", {
                d: "M17 33.3286H21.2521L23.874 26H35L31.7967 36H25.9031H17",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M29.1978 17.6114C32.9565 17.6114 36.0035 14.5644 36.0035 10.8057C36.0035 7.04702 32.9565 4 29.1978 4C25.4391 4 22.3921 7.04702 22.3921 10.8057C22.3921 12.1962 22.8091 13.4893 23.5249 14.5668L22 18L25.4322 16.4756C26.5105 17.1932 27.8053 17.6114 29.1978 17.6114Z",
                fill: "currentColor"
            }),
            jsxRuntime.jsx("path", {
                d: "M23.5249 14.5668L24.1646 14.8509C24.2618 14.6321 24.2404 14.3788 24.1079 14.1794L23.5249 14.5668ZM22 18L21.3603 17.7158C21.2427 17.9805 21.3003 18.2902 21.505 18.495C21.7098 18.6997 22.0195 18.7573 22.2841 18.6397L22 18ZM25.4322 16.4756L25.82 15.8928C25.6205 15.7601 25.367 15.7386 25.148 15.8359L25.4322 16.4756ZM35.3035 10.8057C35.3035 14.1778 32.5699 16.9114 29.1978 16.9114V18.3114C33.3431 18.3114 36.7035 14.951 36.7035 10.8057H35.3035ZM29.1978 4.7C32.5699 4.7 35.3035 7.43362 35.3035 10.8057H36.7035C36.7035 6.66042 33.3431 3.3 29.1978 3.3V4.7ZM23.0921 10.8057C23.0921 7.43362 25.8257 4.7 29.1978 4.7V3.3C25.0525 3.3 21.6921 6.66042 21.6921 10.8057H23.0921ZM24.1079 14.1794C23.4661 13.2132 23.0921 12.0542 23.0921 10.8057H21.6921C21.6921 12.3382 22.1521 13.7654 22.9418 14.9541L24.1079 14.1794ZM22.8851 14.2826L21.3603 17.7158L22.6397 18.2841L24.1646 14.8509L22.8851 14.2826ZM22.2841 18.6397L25.7163 17.1153L25.148 15.8359L21.7159 17.3602L22.2841 18.6397ZM29.1978 16.9114C27.9476 16.9114 26.787 16.5364 25.82 15.8928L25.0444 17.0584C26.2341 17.8501 27.6631 18.3114 29.1978 18.3114V16.9114Z",
                fill: "#212121"
            }),
            jsxRuntime.jsx("path", {
                d: "M27.25 10.7L28.75 12.5L31.25 9.5",
                stroke: "white",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

module.exports = PersonOfficeConfirm;
